// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page--landing[data-v-63c2d62e]{padding-top:1.5rem}@media(min-width:768px){.page--landing[data-v-63c2d62e]{-moz-column-gap:100px;column-gap:100px;padding-top:46px}}@media (min-width: 768px){.page--no-breadcrumbs[data-v-63c2d62e]{padding-top:5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
